
export class FBPixel {
  static itemSubmitted(bundleID, itemTypeName) {
    window._it = itemTypeName;
    window._bundle = bundleID;
  }
}

export default class FB {}
